import { useEffect, useState } from 'react'

const getTime = () => {
  const time = new Date().toLocaleTimeString()
  const cur = time.split(' ')
  return [cur[0].split(':'), cur[1]]
}

// Returns [[hh, mm, ss], AM/PM], ticking every second. Callers render
// time[0][0]/time[0][1] for hh:mm.
export const useClock = () => {
  const [time, setTime] = useState(getTime())

  useEffect(() => {
    const id = setInterval(() => setTime(getTime()), 1000)
    return () => clearInterval(id)
  }, [])

  return time
}
